import { render, staticRenderFns } from "./ThreadPages.vue?vue&type=template&id=3eb01c20&"
import script from "./ThreadPages.vue?vue&type=script&lang=js&"
export * from "./ThreadPages.vue?vue&type=script&lang=js&"
import style0 from "./ThreadPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports